import { api } from '@/api';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import { commitSetTools, commitSetTool, commitDeleteTool } from './mutations';
import { dispatchCheckApiError } from '../main/actions';
import { commitAddNotification, commitRemoveNotification } from '../main/mutations';
import { IToolCreate, IToolUpdate } from '@/interfaces';
import { ToolState } from './state';
import { apiCallNotify } from '../utils';

type ToolContext = ActionContext<ToolState, State>;

export const actions = {
  async actionGetTools(context: ToolContext) {
    try {
      const response = await api.getTools(context.rootState.main.token);
      if (response) {
        commitSetTools(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetOneTool(context: ToolContext, payload: number) {
    try {
      const response = await api.getOneTool(context.rootState.main.token, payload);
      if (response) {
        commitSetTool(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCreateTool(context: ToolContext, payload: IToolCreate) {
    try {
      const response = await apiCallNotify(context, token => api.createTool(token, payload), {
        loadingText: 'Tool wird erstellt',
        successText: 'Tool erfolgreich erstellt',
      });
      commitSetTool(context, response.data);
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
      throw error;
    }
  },
  async actionUpdateTool(context: ToolContext, payload: { id: number; tool: IToolUpdate }) {
    try {
      const response = await apiCallNotify(context, token => api.updateTool(token, payload.id, payload.tool), {
        loadingText: 'Tool wird gespeichert',
        successText: 'Tool erfolgreich aktualisiert',
      });
      commitSetTool(context, response.data);
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
      throw error;
    }
  },
  async actionDeleteTool(context: ToolContext, payload: number) {
    try {
      const loadingNotification = { content: 'Lösche Tool...', showProgress: true };
      commitAddNotification(context, loadingNotification);
      const response = (await Promise.all([
        api.deleteTool(context.rootState.main.token, payload),
        await new Promise<void>((resolve) => setTimeout(() => resolve(), 500)),
      ]))[0];
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, { content: 'Tool gelöscht', color: 'success' });
      commitDeleteTool(context, response.data);
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
};

const { dispatch } = getStoreAccessors<ToolState | any, State>('');

export const dispatchGetTools = dispatch(actions.actionGetTools);
export const dispatchGetOneTool = dispatch(actions.actionGetOneTool);
export const dispatchCreateTool = dispatch(actions.actionCreateTool);
export const dispatchUpdateTool = dispatch(actions.actionUpdateTool);
export const dispatchDeleteTool = dispatch(actions.actionDeleteTool);
